<script lang="ts" setup>
  import { ref } from 'vue';

  import { Badge } from '@ui/components/badge';
  import { Button } from '@ui/components/button';
  import { Popover, PopoverContent, PopoverTrigger } from '@ui/components/popover';

  defineProps<{ label?: string; hideClear?: boolean }>();

  const emits = defineEmits<{
    (e: 'clear'): void;
    (e: 'open', open: boolean): void;
  }>();

  const isValueSelectorOpen = ref(false);
</script>
<template>
  <div class="flex flex-nowrap items-center bg-background rounded box-border h-fit">
    <Badge v-if="label" size="lg" class="rounded-r-none border-r-0" variant="outline">
      {{ label }}
    </Badge>

    <slot v-if="$slots.predicate" name="predicate"></slot>

    <Popover v-model:open="isValueSelectorOpen" @update:open="(v) => emits('open', v)">
      <PopoverTrigger as-child>
        <slot name="popover-trigger" />
      </PopoverTrigger>

      <PopoverContent v-if="$slots['popover-content']" as-child class="p-0">
        <slot name="popover-content" />
      </PopoverContent>
    </Popover>

    <Button
      v-if="!hideClear"
      variant="outline"
      class="rounded-l-none px-2 shadow-none"
      size="icon-sm"
      @click="emits('clear')"
    >
      <i class="fas fa-xmark" />
    </Button>
  </div>
</template>

<style lang="postcss" scoped></style>
